// GET USER
export const getAllUserRequest = "GET_ALL_USER_Request";
export const getAllUserFail = "GET_ALL_USER_Fail";
export const getAllUserSuccess = "GET_ALL_USER_Success";
// ADD USER
export const addNewUserRequest = "ADD_NEW_USER_REQUEST";
export const addNewUserSuccess = "ADD_NEW_USER_SUCCESS";
export const addNewUserFail = "ADD_NEW_USER_FAIL";
// SEARCH USER
export const searchUserRequest = "SEARCH_USER_REQUEST";
export const searchUserSuccess = "SEARCH_USER_SUCCESS";
export const searchUserFail = "SEARCH_USER_FAIL";

